import React, {useCallback} from 'react';
import {assert} from 'assert-ts';
import {Concept} from 'types';
import type {BulkUpdate} from 'api/types';
import type {WorkV4} from 'services/metadata/types';
import {useLocalization} from 'localization';
import {useLazyGetWorksQuery} from 'services/metadata';
import type {GetWorkItemLink} from './BulkUpdatePreviewCore';
import {BulkUpdatePreviewCore} from './BulkUpdatePreviewCore';

type Props = {
  bulkUpdate: BulkUpdate;
};

export const BulkUpdateWorksPreview: React.FC<Props> = ({bulkUpdate}) => {
  const {t} = useLocalization();
  const [getWorksQuery] = useLazyGetWorksQuery();

  assert(
    bulkUpdate.type === Concept.work,
    'BulkUpdateWorksPreview: type work is expected',
  );

  const getNavigationLink = useCallback<GetWorkItemLink>(
    (id, status) => {
      return {
        link: `/metadata/${id}`,
        tooltip: t(`page.bulkUpdate.details.work.link.${status}.tooltip`),
      };
    },
    [t],
  );

  const getItemId = useCallback((data: WorkV4) => {
    return data.id;
  }, []);

  const loader = useCallback(
    (ids: string[]) => {
      return getWorksQuery(ids)
        .unwrap()
        .then(r => r.map(w => w.work));
    },
    [getWorksQuery],
  );

  return (
    <BulkUpdatePreviewCore
      bulkUpdate={bulkUpdate}
      getWorkItemLink={getNavigationLink}
      getItemId={getItemId}
      loader={loader}
    />
  );
};
